import { useCallback } from "react";
import { useFocusEffect } from "@react-navigation/native";

export default (cb: any, deps: any[] = []) => {
  return useFocusEffect(useCallback(cb, deps));
};
